<template>
  <div class="jiuci-page">
    <!-- 模块1：Banner -->
    <section class="banner-section">
      <div class="banner-bg">
        <img src="/banner-九词背景图.jpg" alt="" class="banner-bg-img" />
      </div>
      <div class="container-responsive banner-container">
        <div class="banner-grid">
          <AnimatedSection>
            <div class="banner-text">
              <h1 class="banner-title">九词 NineToken</h1>
              <h2 class="banner-subtitle">每个想法 都能被看见</h2>
              <p class="banner-desc">
                覆盖主流大模型，剧本 · 分镜、AI 生图、AI 生视频、AI 配音一次搞定；一个积分账户全场景通用，创作不再东拼西凑。
              </p>
              <a href="https://ninetoken.qcos.cn/" target="_blank" rel="noopener noreferrer" class="cta-btn">
                <span class="cta-btn-text">立即体验</span>
                <LucideIcon name="arrow-right" :size="16" class="cta-btn-arrow" />
              </a>
            </div>
          </AnimatedSection>
          <AnimatedSection :delay="200">
            <div class="banner-image-wrap">
              <img src="/banner-九词右边图.png" alt="九词  配图" class="banner-image" />
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块2：短剧创作四大痛点 -->
    <section class="challenge-section">
      <div class="container-responsive">
        <AnimatedSection>
          <div class="section-head">
            <h2 class="section-title">短剧创作四大痛点</h2>
            <p class="section-desc">
              从文字到图像到视频，一站式创作，直击内容生产的每个难题
            </p>
          </div>
        </AnimatedSection>
        <div class="challenge-grid">
          <AnimatedSection v-for="(item, i) in challenges" :key="i" :delay="i * 100">
            <div class="challenge-card">
              <div class="challenge-head">
                <div class="challenge-icon-box">
                  <LucideIcon :name="item.icon" :size="20" :stroke-width="2" class="challenge-icon" />
                </div>
                <h3 class="challenge-card-title">{{ item.title }}</h3>
              </div>
              <p class="challenge-desc">{{ item.desc }}</p>
              <div class="challenge-tags">
                <span v-for="(tag, j) in item.tags" :key="j" class="challenge-tag">{{ tag }}</span>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块3：四大核心优势 -->
    <section class="capability-section">
      <div class="container-responsive">
        <AnimatedSection>
          <div class="section-head">
            <h2 class="section-title">四大核心优势</h2>
            <p class="section-desc">
              一个平台，搞定你的所有创作。从灵感到成片，好作品轻松做出来。
            </p>
          </div>
        </AnimatedSection>
        <div class="capability-grid">
          <AnimatedSection v-for="(item, i) in capabilities" :key="i" :delay="i * 100">
            <div class="capability-card">
              <div class="capability-head">
                <div class="capability-icon-box" :style="{ backgroundColor: item.bg }">
                  <LucideIcon :name="item.icon" :size="20" :stroke-width="2" class="capability-icon" />
                </div>
                <h3 class="capability-title">{{ item.title }}</h3>
              </div>
              <p class="capability-desc">{{ item.desc }}</p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 积分计费灵活透明 -->
    <section class="billing-section">
      <div class="container-responsive">
        <AnimatedSection>
          <div class="section-head">
            <h2 class="section-title">积分计费 · 灵活透明</h2>
            <p class="section-desc">
              采用「先充值、后创作、按量扣减」模式，消费透明可控，无任何隐形费用
            </p>
          </div>
        </AnimatedSection>
        <div class="advantage-grid">
          <AnimatedSection v-for="(adv, i) in advantages" :key="i" :delay="i * 100">
            <div class="advantage-card">
              <div class="advantage-icon-wrap">
                <div class="advantage-icon-box">
                  <LucideIcon :name="adv.icon" :size="28" :stroke-width="1.5" class="advantage-icon" />
                </div>
              </div>
              <h3 class="advantage-title">{{ adv.title }}</h3>
              <p class="advantage-desc">{{ adv.desc }}</p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块10：CTA -->
    <section class="cta-section">
      <div class="cta-bg">
        <img src="/底部背景九词.jpg" alt="" class="cta-bg-img" />
      </div>
      <div class="container-responsive cta-content">
        <AnimatedSection>
          <h2 class="cta-title">好内容，从九词开始</h2>
          <p class="cta-desc">
            立即接入九词NineToken，开启高效AI创意之旅
          </p>
          <div class="cta-btn-wrap">
            <a href="javascript:void(0)" class="cta-btn cta-btn-lg" @click="openContact">
              <span class="cta-btn-text">立即预约演示</span>
              <LucideIcon name="arrow-right" :size="16" class="cta-btn-arrow" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  </div>
</template>

<script>
import AnimatedSection from '@/components/AnimatedSection.vue'
import LucideIcon from '@/components/LucideIcon.vue'

export default {
  name: 'JiuciContent',
  components: { AnimatedSection, LucideIcon },
  data() {
    return {
      // 四大痛点数据
      challenges: [
        {
          icon: 'pen-tool',
          title: '剧本 · 分镜 | 无从下笔',
          desc: '选题枯竭、灵感卡壳，盯着空白文档半天憋不出半个字；好不容易憋出初稿，改来改去还是不满意，发布节奏被拖垮，更新越来越吃力，越做越焦虑。',
          tags: ['起笔有光 · 分镜自来']
        },
        {
          icon: 'palette',
          title: 'AI 生图 | 缺图等稿',
          desc: '没有设计师，图片全靠外包排队等档期；好不容易攒的素材，一查是网图怕侵权、不敢商用，配图始终是老大难。',
          tags: ['描述即图 · 多版可用']
        },
        {
          icon: 'video',
          title: 'AI 生视频 | 拍剪难为',
          desc: '请实拍团队成本太高，自己又不懂运镜和剪辑；一条视频从筹拍到成片往往要好几天，更新根本跟不上，只能干着急。',
          tags: ['图文成片 · 一步到位']
        },
        {
          icon: 'mic',
          title: 'AI 配音 | 无声可配',
          desc: '找专业配音贵、自己录音又缺条件，作品始终缺一个好听的声音，画面再用心，成片也大打折扣。',
          tags: ['文稿成声 · 声情并茂']
        }
      ],
      // 四大核心优势
      capabilities: [
        {
          icon: 'layers',
          bg: '#FFA500',
          title: '一站式创作',
          desc: '剧本、生图、生视频、配音，不再切来切去、到处倒数据；从选题到出稿一处做完，效率翻倍。'
        },
        {
          icon: 'zap',
          bg: '#FF5740',
          title: '零门槛 · 即开即用',
          desc: '注册即可上手，无需复杂配置；提个需求就能出作品，不用学提示词、不啃教程，小白也能用。'
        },
        {
          icon: 'shield-check',
          bg: '#FF8C42',
          title: '稳定 · 安全 · 放心用',
          desc: '长期稳定运行，高峰时段也流畅不卡；内容经过安全审核，合规有保障，商业创作踏实放心。'
        },
        {
          icon: 'sparkles',
          bg: '#F43F5E',
          title: '智能调度 · 效果更佳',
          desc: '聚合主流大模型，按你的创作内容自动选对模型，效果始终在线；不用钻研参数、反复试错，省心省力，出片更快。'
        }
      ],
      // 积分计费灵活透明
      advantages: [
        { icon: 'package', title: '灵活选购套餐', desc: '按需选购积分额度，支持多种规格组合，满足不同阶段创作与业务需求。' },
        { icon: 'coins', title: '按量扣减', desc: '每次创作按实际消耗实时扣减，精准计量，拒绝浪费。' },
        { icon: 'calendar', title: '有效期灵活设定', desc: '支持按年或月设定有效周期，有效期内随时使用，到期前支持无缝续购。' },
        { icon: 'bar-chart-3', title: '用量实时可查', desc: '积分余额与消耗明细实时更新，支持按创作场景、模型维度查询明细账单。' }
      ]
    }
  },
  methods: {
    // 打开 Header 中的联系我们弹窗（站内约定，同 LeapoAiContent）
    openContact() {
      this.$root.$emit('openContactUs', '九词Token算力平台')
    }
  }
}
</script>

<style scoped>
.jiuci-page {
  background: #fff;
  text-align: left;
}

/* ---------- 响应式容器（源项目为全局类，此处随组件移植） ---------- */
.container-responsive {
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 768px) {
  .container-responsive {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (min-width: 1200px) {
  .container-responsive {
    max-width: 1400px;
  }
}
@media (min-width: 1600px) {
  .container-responsive {
    max-width: 1600px;
  }
}
@media (min-width: 1920px) {
  .container-responsive {
    max-width: 1800px;
  }
}

/* ---------- Banner ---------- */
.banner-section {
  position: relative;
  overflow: hidden;
  background: #fff;
}
@media (min-width: 768px) {
  .banner-section {
    height: 600px;
  }
}
.banner-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
@media (min-width: 768px) {
  .banner-bg {
    display: flex;
  }
}
.banner-bg-img {
  width: 1690px;
  height: 600px;
  object-fit: cover;
}
.banner-container {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 120px;
}
.banner-grid {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
}
@media (min-width: 768px) {
  .banner-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 48px;
  }
}
.banner-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin: 0 0 12px;
}
.banner-subtitle {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin: 0 0 20px;
}
.banner-desc {
  font-size: 13px;
  color: #666666;
  line-height: 1.625;
  margin: 0 0 24px;
  max-width: 560px;
}
@media (min-width: 768px) {
  .banner-title {
    font-size: 44px;
  }
  .banner-subtitle {
    font-size: 56px;
  }
  .banner-desc {
    font-size: 15px;
  }
}
.banner-image-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.banner-image {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
}
@media (min-width: 768px) {
  .banner-image {
    max-height: none;
  }
}

/* ---------- 通用按钮 ---------- */
.cta-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  background: #000;
  color: #fff;
  width: 160px;
  overflow: hidden;
  text-decoration: none;
  transition: all 0.3s;
}
@media (min-width: 768px) {
  .cta-btn {
    width: 180px;
    font-size: 16px;
  }
  .cta-btn-lg {
    padding: 12px 24px;
  }
}
.cta-btn-text {
  transition: transform 0.3s ease-out;
}
.cta-btn:hover .cta-btn-text {
  transform: translateX(-4px);
}
.cta-btn-arrow {
  position: absolute;
  right: 24px;
  opacity: 0;
  transform: translateX(8px);
  transition: all 0.3s ease-out;
}
.cta-btn:hover .cta-btn-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* ---------- 通用区块标题 ---------- */
.section-head {
  text-align: center;
  margin-bottom: 48px;
}
@media (min-width: 768px) {
  .section-head {
    margin-bottom: 64px;
  }
}
.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
.section-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  margin: 0;
}
@media (min-width: 768px) {
  .section-title {
    font-size: 36px;
  }
  .section-desc {
    font-size: 16px;
  }
}

/* ---------- 四大痛点 ---------- */
.challenge-section {
  padding: 64px 0;
  background: #f9fafb;
}
@media (min-width: 768px) {
  .challenge-section {
    padding: 112px 0;
  }
}
.challenge-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 768px) {
  .challenge-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.challenge-grid > .animated-section {
  height: 100%;
}
.challenge-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.challenge-head {
  margin-bottom: 16px;
}
.challenge-icon-box {
  width: 40px;
  height: 40px;
  background: rgba(255, 140, 66, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.challenge-icon {
  color: #ff8c42;
}
.challenge-card-title {
  font-size: 17px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
@media (min-width: 768px) {
  .challenge-card-title {
    font-size: 18px;
  }
}
.challenge-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0 0 24px;
}
.challenge-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
}
.challenge-tag {
  padding: 4px 12px;
  background: #f3f4f6;
  color: #666666;
  font-size: 12px;
  border-radius: 9999px;
}

/* ---------- 四大核心优势 ---------- */
.capability-section {
  padding: 64px 0;
  background: #fff;
}
@media (min-width: 768px) {
  .capability-section {
    padding: 112px 0;
  }
}
.capability-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 768px) {
  .capability-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.capability-card {
  border-radius: 16px;
  padding: 24px;
  background: #fff;
  border: 1px solid #f5f5f5;
  height: 100%;
}
.capability-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.capability-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.capability-icon {
  color: #fff;
}
.capability-title {
  font-size: 17px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
@media (min-width: 768px) {
  .capability-title {
    font-size: 18px;
  }
}
.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}

/* ---------- 积分计费 ---------- */
.billing-section {
  padding: 64px 0;
  background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
}
@media (min-width: 768px) {
  .billing-section {
    padding: 112px 0;
  }
}
.advantage-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 768px) {
  .advantage-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.advantage-grid > .animated-section {
  height: 100%;
}
.advantage-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid transparent;
}
.advantage-icon-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
.advantage-icon-box {
  width: 56px;
  height: 56px;
  border-radius: 9999px;
  background: linear-gradient(to bottom right, rgba(255, 140, 66, 0.1), rgba(255, 87, 64, 0.1));
  display: flex;
  align-items: center;
  justify-content: center;
}
.advantage-icon {
  color: #ff8c42;
}
.advantage-title {
  font-size: 17px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
@media (min-width: 768px) {
  .advantage-title {
    font-size: 18px;
  }
}
.advantage-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  flex: 1;
  margin: 0;
}

/* ---------- CTA ---------- */
.cta-section {
  height: 400px;
  background: #eef0f6;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cta-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.cta-bg-img {
  width: 1600px;
  height: 400px;
  object-fit: cover;
  object-position: center;
}
.cta-content {
  text-align: center;
  position: relative;
  z-index: 10;
}
.cta-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
.cta-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  margin: 0;
}
@media (min-width: 768px) {
  .cta-title {
    font-size: 36px;
  }
  .cta-desc {
    font-size: 16px;
  }
}
.cta-btn-wrap {
  margin-top: 24px;
}
@media (min-width: 768px) {
  .cta-btn-wrap {
    margin-top: 32px;
  }
}
</style>
